import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs';

import { createEffectFactory } from '@core/ngrx-legacy';

import { DataSourceActions } from './data-source.store';
import { ViewsDataService } from '../../services/views-data.service';

@Injectable({ providedIn: 'root' })
export class DataSourceEffects {
  private readonly actions$ = inject(Actions);
  private readonly viewsHttpService = inject(ViewsDataService);

  public effect = createEffectFactory(DataSourceActions, this.actions$);

  public fetchOne$ = this.effect(DataSourceActions.fetchOne, ({ payload: { id } }) =>
    this.viewsHttpService.fetchDataSource(id).pipe(map(data => ({ data }))),
  );
}
